import graphql from "babel-plugin-relay/macro";

const updatePictureMutation = graphql`
  mutation updatePictureMutation($id: ID!, $recipe: ID!) {
    recipeMediaUpdate(input: { id: $id, recipe: $recipe }) {
      recipeMedia {
        id
        file
      }
    }
  }
`;

export default updatePictureMutation;
